<template>
  <div class="user-management">
    <!-- 查询条件 -->
    <!-- <div class="user-management-query">
      <div class="user-management-input">
        <div class="flex-item">
          <base-input
            v-model="selectQuery.username"
            title='用户名'
            placeholder="请输入"
          />
        </div>
        <div class="flex-item">
          <base-input
            v-model="selectQuery.realname"
            title='姓名'
            placeholder="请输入"
          />
        </div>
        <div class="flex-item">
          <span class="query-text">所属区域：</span>
          <base-select
            v-model="selectQuery.userRegions"
            color="blue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areaOption"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </base-select>
        </div>
      </div>
      <base-button color="blue" @click='handleSearch' v-loading="tableLoading">
        查询
      </base-button>
    </div> -->
    <div class="user-management-add">
      <div class='add-title'>
        <span>用户管理列表</span>
      </div>
      <base-button color="red" class='add-btn' @click="handleOpenDialog('')" v-show="!tableLoading">
        新增
      </base-button>
    </div>

    <base-table
      class="table-box"
      :data="listComputed"
      v-loading="tableLoading"
    >
      <el-table-column
        prop="username"
        label="用户名"
        show-overflow-tooltip
        :resizable="false"
        align='center'
      />
      <el-table-column
        prop="realname"
        label="姓名"
        show-overflow-tooltip
        :resizable="false"
        align='center'
      />
      <el-table-column
        prop="sex"
        label="性别"
        width="60"
        show-overflow-tooltip
        :resizable="false"
        align='center'
      >
        <!-- <template slot-scope="scope">
          <span>
            {{ scope.row.sex ? (scope.row.sex == '1' ?  '男' : '女') : '' }}
          </span>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="mobilePhone"
        label="手机号码"
        show-overflow-tooltip
        :resizable="false"
        align='center'
      />
      <el-table-column
        prop="userRegionStr"
        label="所属区域"
        show-overflow-tooltip
        :resizable="false"
        align='center'
      />
      <el-table-column
        label="操作"
        :resizable="false"
        width="180"
        align='center'
      >
        <template slot-scope="scope">
          <base-button
            type="text"
            color="blue"
            @click="handleOpenDialog(scope.row)"
          >
            编辑
          </base-button>
          <base-button
            type="text"
            color="red"
            @click="handleReset(scope.row)"
          >
            重置密码
          </base-button>
          <base-button
            type="text"
            color="red"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </base-button>
        </template>
      </el-table-column>
    </base-table>

    <base-pagination
      v-show="pagination.total > 0"
      :total="pagination.total"
      :current-page.sync="pagination.pageIndex"
      :page-size.sync="pagination.pageSize"
      @pagination="setPagination"
    />

    <!-- 新增（编辑）用户弹窗 -->
    <base-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <div class="dialog-content">
        <div class="dialog-content-item">
          <span class="item-text">用户名：</span>
          <base-input
            width="246"
            :isTitle="false"
            v-model="addTableList.username"
            :disabled='isPassword'
          />
            <!-- @blur="handleEmployeeId" -->
          <i class="el-icon-warning" style='color:#e6795d' v-show="isTrue"></i>
        </div>
        <div class="dialog-content-item">
          <span class="item-text">姓名：</span>
          <base-input
            :isTitle="false"
            v-model="addTableList.realname"
            necessary
          />
        </div>
        <div class="dialog-content-item">
          <span class="item-text item-no-text">性别：</span>
          <base-select
            v-model="addTableList.sex"
            color="blue"
          >
            <el-option
              v-for="item in setOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </base-select>
        </div>
        <div class="dialog-content-item">
          <span class="item-text">密码：</span>
          <base-input
            width="246"
            :isTitle="false"
            v-model="addTableList.password"
            type="password"
            :disabled='isPassword'
            @blur="handlePsd"
            necessary
          />
          <i class="el-icon-warning" style='color:#e6795d' v-show="isPsd"></i>
        </div>
        <div class="dialog-content-item">
          <span class="item-text">电话号码：</span>
          <base-input
            :isTitle="false"
            v-model="addTableList.mobilePhone"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
          />
        </div>
        <div class="dialog-content-item">
          <span class="item-text">用户角色：</span>
          <el-select v-model="addTableList.isAdmin" placeholder="请选择">
            <el-option
              v-for="item in roleData"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-content-item role-box">
          <span class="item-text">所属区域：</span>
          <base-select
            v-model="addTableList.userRegionCode"
            color="blue"
            multiple
          >
            <!-- @change="handleChange" -->
            <el-option
              v-for="item in areaOption"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </base-select>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <base-button
          color="blue"
          @click="() => (dialogVisible = false)"
        >
          取 消
        </base-button>
        <base-button
          color="blue"
          bg-color
          @click="handleAddTable"
          v-loading="add$update"
        >
          确 定
        </base-button>
      </span>
    </base-dialog>
    <!-- 区域弹窗 -->
    <!-- <base-dialog title="区域" :visible.sync="dialogVisible1" dialogSize="small">
      <div class="dialog-content">
        <div class="dialog-content-item">
          <span class="item-text">所属区域：</span>
          <base-select
            v-model="userRegions"
            color="blue"
            multiple
            @change="handleChange"
          >
            <el-option
              v-for="item in areaOption"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </base-select>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <base-button
          color="blue"
          @click="() => (dialogVisible1 = false)"
        >
          取 消
        </base-button>
        <base-button
          color="blue"
          bg-color
          @click="handleArea"
        >
          确 定
        </base-button>
      </span>
    </base-dialog> -->

  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput'
import BaseButton from '@/components/BaseButton'
import BaseTable from '@/components/BaseTable'
import BasePagination from '@/components/BasePagination'
import BaseDialog from '@/components/BaseDialog'
import BaseSelect from '@/components/BaseSelect'
// import BaseCascader from '@/components/BaseCascader'
import {
  getListUser,
  saveUser,
  getInfo,
  updateUser,
  deleteUser,
  getAllRegion,
  SaveOrEdit,
  userReset,
} from './service.js'

export default {
  name: 'UserManagement',
  components: {
    BaseInput,
    BaseButton,
    BaseSelect,
    BaseTable,
    BasePagination,
    BaseDialog,
  },
  data () {
    return {
      path: {
        // listDept: '/rest/sys/dept/listDept',
      },
      roleData: [
        { name: '管理员', value: '0' },
        { name: '普通用户', value: '1' },
      ],
      selectQuery: {
        username: '',
        realname: '',
        userRegions: '',
      },
      areaOption: [],
      setOption: [
        { label: '男', value: '男' },
        { label: '女', value: '女' },
      ],
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      listComputed: [],
      tableLoading: false,
      // dialogVisible1: false,
      addTableList: {
        username: '',
        realname: '',
        sex: '男',
        password: '',
        mobilePhone: '',
        isAdmin: '1',
        userRegionCode: '',
      },
      dialogTitle: '新增用户',
      dialogVisible: false,
      add$update: false,
      isPassword: false,
      isTrue: false,
      isPsd: false,
      // userRegionCode: '',
      // areaObject: {
      //   regionId: '',
      //   userId: '',
      //   id: '',
      // }
    }
  },
  computed: {
  },
  created () {
    this.getAllRegion()
    let params = { pageIndex: 1, pageSize: 10 }
    this.getListUser(params)
  },
  beforeDestroy () {
  },
  methods: {
    /**
     * @description: 获取部门列表
     * @return       null
     */
    async getAllRegion () {
      let res = await getAllRegion()
      if (res.code === 'success') {
        this.areaOption = res.data.list
      }
    },
    async getListUser (params) {
      this.tableLoading = true
      let res = await getListUser(params)
      this.tableLoading = false
      if (res.code === 'success') {
        let { list, total } = res.data
        this.pagination.total = total
        this.listComputed = list.map(res => {
          let userRegionStr = []
          res.userRegions.forEach(({ regionName }) => (regionName && userRegionStr.push(regionName)))
          res.userRegionStr = userRegionStr.length ? userRegionStr.join() : ''
          return res
        })
      }
    },
    /**
     * @description: 选择页数
     * @param        nummber e [选择的页数]
     */
    setPagination (e) {
      this.pagination.pageIndex = e
      let params = { pageIndex: e, pageSize: 10 }
      this.getListUser(params)
    },
    /**
     * 重置密码操作
     */
    async handleReset ({ id }) {
      this.$confirm('此操作将重置该账号密码为111111, 是否继续?', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      })
        .then(async (active) => {
          if (active === 'confirm') {
            const res = await userReset({ id })
            this.$notify({ message: res.msg, type: res.code === 'success' ? 'success' : 'error' })
          }
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消' })
        })
    },
    /**
     * 打开新增弹窗将所属部门的数据类型进行转化展示
     */
    async handleOpenDialog ({ id, username }) {
      this.dialogVisible = true
      this.add$update = false
      this.isTrue = false
      this.isPsd = false

      if (!id) {
        this.isPassword = false
        this.dialogTitle = '新增用户'
        this.addTableList = {
          username: '',
          realname: '',
          sex: '男',
          password: '',
          mobilePhone: '',
          isAdmin: '1',
          userRegionCode: '',
        }
        return
      }
      /* 编辑信息 */
      this.dialogTitle = '编辑用户'
      let res = await getInfo({ username })
      this.isPassword = true
      if (res.code === 'success') {
        let { userRegions } = res.data
        let userRegionCode = []
        userRegions && userRegions.forEach(({ regionCode }) => (regionCode && userRegionCode.push(regionCode)))

        this.addTableList = { ...res.data, userRegionCode }
      } else {
        this.$message.error(`获取信息失败${res.msg}`)
      }
    },
    /**
     * @description: 删除账号
     * @param        {string} id 用户id
     */
    async handleDelete (id) {
      this.$confirm('此操作将删除该账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await deleteUser({ id })
          if (res.code === 'success') {
            this.$message({ message: '账号删除成功', type: 'success' })
            let { pageIndex, pageSize } = this.pagination
            let params = { pageIndex, pageSize }

            this.getListUser(params)
          } else {
            this.$message.error(`账号删除失败：${res.msg}`)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    /**
     * @description: 查询
     * @return       null
     */
    handleSearch () {
      let params = { pageIndex: 1, pageSize: 10 }
      this.getListUser(params)
    },
    /**
     * 新增编辑用户确认操作将所属部门进行数据转化发送请求
     */
    async handleAddTable () {
      let { username, realname, sex, password, mobilePhone, isAdmin, userRegionCode, id } = this.addTableList
      const params = { username, realname, sex, password, mobilePhone, isAdmin, regionCode: userRegionCode && userRegionCode.join() }

      for (let k in params) {
        if (k === 'sex') continue
        if (!params[k]) {
          this.$message.error('请检查*号是否填写！')
          return
        }
      }
      if (id) {
        params.id = id
        delete params.password
      }

      // 保存/修改用户
      this.add$update = true
      const res = await saveUser(params)
      this.add$update = false
      if (res.code === 'success') {
        this.dialogVisible = false
        this.$message({ message: res.msg, type: 'success' })

        let params = { pageIndex: 1, pageSize: 10 }
        this.pagination.pageIndex = 1
        this.getListUser(params)
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * @description:          用户名校验
     * @param {Object}  e     event
     * @return                undefined
     */
    async handleEmployeeId (e) {
      const params = { username: e.target.value }
      const res = await isExist(params)

      if (res.code === 0) {
        this.isTrue = false
      } else {
        this.isTrue = true
        this.$message.error('用户名已被使用,请重新填写!')
      }
    },
    /**
     * @description:          密码格式校验
     * @param {Object}  e     event
     * @return                undefined
     */
    handlePsd (e) {
      let psd = e.target.value
      this.isPsd = false
      if (psd.length < 6) {
        this.isPsd = true
        this.$message.error('密码长度至少六位!')
      }
    },
    // 打开区域弹框
    // handleOpenArea (id) {
    //   this.areaObject.userId = id
    //   this.dialogVisible1 = true
    // },
    // 选择区域
    // handleChange (code) {
    //   this.userRegionCode = code.join()
    // },
    // 新增、编辑所属区域
    // async handleArea () {
    //   let codeArr = this.areaObject.regionId.split(',')
    //   let idArr = this.areaOption.filter(({ code }) => codeArr.indexOf(code) !== -1)
    //   this.areaObject.id = idArr.reduce((total, { id }) => {
    //     return total += `,${id}`
    //   }, '').substr(1)

    //   let res = await SaveOrEdit(this.areaObject)
    //   if (res.code === 'success') {
    //     this.dialogVisible1 = false
    //     this.$message({ message: res.msg, type: 'success' })
    //     let { pageIndex, pageSize } = this.pagination
    //     let params = { pageIndex, pageSize }

    //     this.getListUser(params)
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    // },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/static/style/common';
.user-management {
  width: 98%;
  margin: 10px auto;
  .user-management-query {
    height: 36px;
    padding: 20px 30px;
    background: #fff;
    border-radius: 5px;
    margin-bottom: 10px;
    .el-button {
      float: right;
    }
    .user-management-input {
      display: flex;
      float: left;
      .flex-item {
        width: 240px;
        grid-template-columns: auto;
        .query-text {
          display: inline-block;
          font-size: @ec-font-size-main;
          color: @ec-color-text-main;
          margin-right: 12px;
        }
      }
      /deep/ .el-input {
        width: 140px;
      }
    }
  }
  .user-management-add {
    background: #fff;
    height: 60px;
    line-height: 60px;
    padding: 0 30px;
    border: 1px solid transparent;
    box-sizing: border-box;
    .add-title {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      &::before {
        display: inline-block;
        content: '';
        width: 0px;
        height: 10px;
        border: 2px solid #1890FF;
        vertical-align: -1px;
        margin-right: 5px;
      }
    }
    .add-btn {
      float: right;
      margin-top: 10px;
      margin-right: 20px;
    }
  }
  .table-box {
    background-color: #fff;
  }
  .dialog-content {
    .item-no-text {
      &::before {
        display: none;
      }
    }
    .role-box {
      width: 775px;
      /deep/ .el-input {
        width: 688px;
      }
    }
  }
}
</style>
